import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1b05ad9b-00ea-4f44-a8ab-b9119f3f327f/artifacts/eb517133_Design%20ohne%20Titel%20%2811%29.png";

const Footer = () => {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();

  const labels = {
    impressum: {
      ar: "البيانات القانونية",
      de: "Impressum",
      en: "Imprint",
      fa: "اطلاعات قانونی",
    },
    datenschutz: {
      ar: "سياسة الخصوصية",
      de: "Datenschutz",
      en: "Privacy Policy",
      fa: "حریم خصوصی",
    },
  };

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[rgba(31,107,122,0.1)] py-8 bg-white/40"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8 flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center">
          <Link to="/">
            <img
              src={LOGO_URL}
              alt="Kompass Heidelberg"
              className="object-contain"
              style={{
                mixBlendMode: "multiply",
                height: "clamp(56px, 7vw, 80px)",
                width: "auto",
              }}
            />
          </Link>
        </div>

        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm">
          <Link
            to="/impressum"
            data-testid="footer-impressum"
            className="text-[color:var(--kompass-ink-soft)] hover:text-[color:var(--kompass-primary)] transition-colors"
          >
            {labels.impressum[lang] || labels.impressum.de}
          </Link>
          <span className="text-[color:var(--kompass-muted)]">·</span>
          <Link
            to="/datenschutz"
            data-testid="footer-datenschutz"
            className="text-[color:var(--kompass-ink-soft)] hover:text-[color:var(--kompass-primary)] transition-colors"
          >
            {labels.datenschutz[lang] || labels.datenschutz.de}
          </Link>
        </nav>

        <div className="text-xs text-[color:var(--kompass-muted)] text-center md:text-end">
          © {year} Kompass Heidelberg · {t.footer.built} · {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
